import { Component } from '@angular/core';
import { FadeInDirective } from '../../directives/fade-in.directive';
import { NgIf } from '@angular/common';
import { RouterModule, Router } from '@angular/router';

@Component({
  selector: 'app-footer',
  standalone: true,
  imports: [FadeInDirective, NgIf, RouterModule],
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss']
})
export class FooterComponent {

  constructor(
    public router: Router,
  ) { }

  isPolicyPage(): boolean {
    return this.router.url === '/polityka-prywatnosci';
  }

  isConfirmationPage(): boolean {
    return this.router.url.startsWith('/confirm-email');
  }

  scrollTo(id: string, event?: Event): void {
    if (event) {
      event.preventDefault();
    }
    const element = document.getElementById(id);
    if (element) {
      const yOffset = id === 'juno' ? -200 : -100;
      const y = element.getBoundingClientRect().top + window.scrollY + yOffset;
      window.scrollTo({ top: y, behavior: 'smooth' });
    }
  }

}
